export default {"src":"/_next/static/media/peep-org.24ef55c6.svg","height":1500,"width":1500};